import {
  applyMiddleware,
  compose,
  createStore,
} from 'redux'
import AppReducer from './AppReducers';

const composeEnhancers =
 // (typeof window !== "undefined" &&
 //   window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const Store = createStore(
  AppReducer,
  composeEnhancers()
);
export default Store;